import { FormattedMessage } from 'react-intl'

export const ErxBonusLandingPageHowBonusIsCalculatedTableDataBody = [
  {
    key: 'data-1',
    medication: '3 x Medikamente A',
    perscriptionBonus: '2,50 €',
    totalBonus: '7,50 €',
  },
  {
    key: 'data-2',
    medication: '1 x Medikament B',
    perscriptionBonus: '5,00 €',
    totalBonus: '5,00 €',
  },
  {
    key: 'data-3',
    medication: '1 x Medikament C',
    perscriptionBonus: '2,50 €',
    totalBonus: '2,50 €',
  },
]

export const ErxBonusLandingPageHowBonusIsCalculatedTableDataHead = [
  {
    heading: (
      <FormattedMessage id="deErx.oldBonus.HowPrescriptionIsCalculated.table.head.medication" />
    ),
    key: 'heading-1',
  },
  {
    heading: (
      <FormattedMessage id="deErx.oldBonus.HowPrescriptionIsCalculated.table.head.prescriptionBonus" />
    ),
    key: 'heading-2',
  },
  {
    heading: (
      <FormattedMessage id="deErx.oldBonus.HowPrescriptionIsCalculated.table.head.totalBonus" />
    ),
    key: 'heading-3',
  },
]
